import axios from "axios";
import { BASE_URL } from "../config/config";

// Get Cart (for logged-in user)

export const getCart = async () => {
  const token = sessionStorage.getItem("authToken");
  if (!token) return { cartDetails: [] }; // match the structure expected in useEffect

  try {
    const response = await axios.post(
      `${BASE_URL}/getCartDetails`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; // returns { status, message, cartDetails }
  } catch (error) {
    console.error("Error fetching cart:", error);
    return { cartDetails: [] }; // return the same structure even on error
  }
};

export const addToCartAPI = async (cartItem) => {
  const token = sessionStorage.getItem("authToken");
  if (!token) return;

  try {
    const response = await axios.post(
      `${BASE_URL}/addToCart`,
      {
        cartData: [cartItem], // wrap in array as per your backend
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding to cart:", error);
  }
};

// delete
export const deleteCart = async ({ product_id, size }) => {
  const token = sessionStorage.getItem("authToken");
  if (!token) return { status: "error", message: "Not authenticated" };

  try {
    const response = await axios.post(
      `${BASE_URL}/delete_product_from_cart`,
      { product_id, size },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting from cart:", error);
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to delete item",
    };
  }
};

export const updateCartQuantityAPI = async ({ product_id, size, change }) => {
  const token = sessionStorage.getItem("authToken");
  if (!token) {
    console.warn("No token found in sessionStorage");
    return { status: false, message: "No auth token" };
  }

  try {
    const response = await axios.post(
      `${BASE_URL}/updateCartDetails`,
      {
        product_id,
        size: size || "",
        change: Number(change),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update cart quantity failed:", error.response?.data || error.message);
    return {
      status: false,
      message: "Failed to update cart quantity",
    };
  }
};









